import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail, ArrowLeft } from "lucide-react";
import { api, formatApiError } from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-16 flex items-center justify-center px-4 carbon-texture">
      <div className="w-full max-w-md rounded-2xl backdrop-blur-xl bg-slate-900/80 border border-white/10 shadow-2xl p-8 animate-fade-up">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-lg bg-cyan-400/10 border border-cyan-400/40 flex items-center justify-center">
            <ShieldCheck className="w-5 h-5 text-cyan-300" />
          </span>
          <h1 className="text-2xl font-bold text-white">Şifre Sıfırlama</h1>
        </div>

        {sent ? (
          <div data-testid="forgot-success" className="mt-6">
            <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-5">
              <p className="text-sm text-emerald-300 font-semibold">Bağlantı gönderildi</p>
              <p className="mt-2 text-sm text-slate-300 leading-relaxed">
                Bu e-posta adresi kayıtlıysa şifre sıfırlama bağlantısı gönderildi. Lütfen e-posta kutunuzu
                (ve spam klasörünü) kontrol edin. Bağlantı 1 saat geçerlidir.
              </p>
            </div>
            <Link to="/giris" className="mt-6 inline-flex items-center gap-2 text-sm text-cyan-300 hover:text-cyan-200 font-semibold">
              <ArrowLeft className="w-4 h-4" /> Giriş sayfasına dön
            </Link>
          </div>
        ) : (
          <>
            <p className="mt-2 text-sm text-slate-400">
              E-posta adresinizi girin; şifre sıfırlama bağlantısı gönderelim.
            </p>
            <form onSubmit={submit} className="mt-7 space-y-5">
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider">E-posta</label>
                <input data-testid="forgot-email-input" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1.5 w-full px-4 py-3 rounded-xl bg-slate-950/70 border border-white/10 text-slate-100 focus:outline-none focus:border-cyan-400/60 transition-colors"
                  placeholder="ornek@eposta.com" />
              </div>
              {error && <p data-testid="forgot-error" className="text-sm text-red-400">{error}</p>}
              <button data-testid="forgot-submit-button" type="submit" disabled={loading}
                className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl bg-cyan-400 text-slate-950 font-bold hover:bg-cyan-300 hover:shadow-[0_0_20px_rgba(249,115,22,0.4)] active:scale-[0.99] transition-all disabled:opacity-50">
                <Mail className="w-4 h-4" /> {loading ? "Gönderiliyor..." : "Sıfırlama Bağlantısı Gönder"}
              </button>
            </form>
            <p className="mt-6 text-sm text-slate-400 text-center">
              <Link data-testid="forgot-back-login" to="/giris" className="text-cyan-300 hover:text-cyan-200 font-semibold">
                Giriş sayfasına dön
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
